import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function OAuthSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      navigate("/gauth", { replace: true });
      return;
    }

    // Store JWT
    localStorage.setItem("token", token);

    // Remove token from URL
    window.history.replaceState({}, document.title, "/oauth/success");

    // ✅ Pass success state
    navigate("/createposts", {
      replace: true,
      state: { loginSuccess: true },
    });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600 text-sm">Signing you in…</p>
    </div>
  );
}
